<div *ngIf="isDisplayMenuButton" class="menuIcon" (click)="onMenuButtonClick()">
    <button mat-icon-button class="color-white">
        <mat-icon [attr.role]="null">menu</mat-icon>
    </button>
</div>

<header class="headersection" style="display: flex;" [ngStyle]="getStyle()">
    <div class="wow fadeInLeft">
        <a>
            <img [style.width.px]="400" class="logo_image cognix-logo-theme" alt="Logo Image"
                src="{{userInfo.HeaderLogo}}">

        </a>
        <!-- <a> -->
        <!-- <img  [style.width.px]="400"  [style.height.px]="50" class="logo_image cognix-logo-theme" src="../../assets/img/PI_Ideas_header.png"> -->
        <!-- <img class="logo_image cognix-logo-theme" src="../../assets/img/PI_Ideas_header1.png">   -->
        <!-- <img class="logo_image cognix-logo-theme" src="../../assets/img/tcs-cognix.png">  -->
        <!-- <img  [style.width.px]="400"  [style.height.px]="50" class="logo_image cognix-logo-theme" src="../../assets/img/PI_Ideas_header.png"> -->

        <!-- <span class="group_name">{{userInfo.groupName}}</span> -->

        <!-- <p class="logo_text">Vendor Portal</p> -->
        <!-- </a> -->
    </div>
    <div class="wow fadeInRight headerRight">

        <div>
            <img style="height: 35px !important; margin-top: 1px !important;" [src]="userInfo.groupLogo"
                class="group_logo" alt="{{userInfo.groupName}}">
            <span class="separate_line"></span>
        </div>
        <!-- <div class="headIcon headIconExca Cur"> -->
        <!-- <i [matMenuTriggerFor]="exclamationMenu" class="bi bi-question-lg" title="Help"></i> -->

        <!-- <i  style="height: auto !important;" class="bi bi-question-lg" title="Help" [routerLink]="['/help-section']"> /i> -->

        <!-- <img   style="height: 35px; margin-right: 8px;" [matMenuTriggerFor]="userInfoMenu" src="../../assets/img/VBX.jpg"> -->
        <!-- <i class="bi bi-question-lg" title="Help" [routerLink]="['/help-section']"></i> -->
        <!-- </div> -->
        <div class="userdetail">
            <div>
                <img  #imgRef style="height: auto !important;" [matMenuTriggerFor]="userInfoMenu" alt="User"
                    src="../../assets/img/user.png" aria-hidden="true" >
            </div>
            <p class="header_user_name">{{userInfo.userName}}</p>
            <p class="header_user_role">{{userInfo.roleName}}</p>
            <mat-menu #userInfoMenu="matMenu">
                <button mat-menu-item>
                    <mat-icon>mail_outline</mat-icon>
                    <span>{{userInfo.userEmail}}</span>
                </button>
                <button mat-menu-item title="Last active session at">
                    <mat-icon>access_time</mat-icon>
                    <span>{{userInfo.lastLoginAt|date:'medium'}}</span>
                </button>
                <mat-divider></mat-divider>
                <div class="section-title">
                    <!-- <mat-icon> call_split</mat-icon>  -->
                    Hierarchy
                </div>
                <button mat-menu-item title="Project">
                    <mat-icon>check_circle_outline</mat-icon>
                    <span>{{userInfo.projectName}}</span>
                </button>
                <!-- <button *ngIf="userInfo.subgroupName!=''" mat-menu-item title="Subgroup">
                    <mat-icon>check_circle_outline</mat-icon>
                    <span>{{userInfo.subgroupName}}</span>
                </button> -->
                <mat-divider></mat-divider>
                <div class="section-title">
                    Language
                </div>
                <button mat-menu-item title="Language">
                    <mat-icon>language</mat-icon>
                    <a href="javascript:void(0)"
                        (click)="toggleGlobalModal.emit(true);showModal(languageModal,'sm')">{{userInfo.language}}</a>
                </button>
            </mat-menu>
        </div>
        <div *ngIf="isDisplayMenuButton" (click)="onLogoutButtonClick()" class="loggoff">
            <img src="../../assets/img/logoff.png" alt="Logout" style="height: auto !important;">
        </div>
    </div>
</header>

<ng-template #languageModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Choose your Language</h5>
            <button type="button" class="close model_close_btn"
                (click)="toggleGlobalModal.emit(false);modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <!-- <li [class.selected]="commonService.getUserInfoFromLocalStorage('language') == lan" -->
                        <!-- <li [class.selected]="commonService.getcookiedata('language') == lan" -->
                        <li [class.selected]="memorystore.getItem('language') == lan"
                        *ngFor="let lan of languages" (click)="changeLanguage(lan)">
                        <div class="selected-check">{{lan.language_name}} ({{lan.language_code}})</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<mat-menu #queryMenu="matMenu">
    <button mat-menu-item *ngFor="let msg of lstTop5Query;let i = index;" (click)="queryClick(msg.queryId)">
        <mat-icon>question_answer</mat-icon>
        <span [ngStyle]="getQueryStyle(i)">{{msg.Title}}</span>
    </button>
    <button mat-menu-item *ngIf="lstQuery.length>5" (click)="queryClick(-1)" class="textRight">
        <span>More...</span>
    </button>
    <button mat-menu-item *ngIf="lstQuery.length==0">
        <span>No Query found.</span>
    </button>
</mat-menu>

<!-- <mat-menu #exclamationMenu="matMenu">
    <button mat-menu-item [routerLink]="['/help-section']">
        <span><i class="bi bi-exclamation-circle"></i>
            Help</span>
    </button>
    <button mat-menu-item>
        <span> <i class="bi bi-download"></i>
            Manual Download</span>
    </button>
    <button mat-menu-item>
        <span><i class="bi bi-question-circle"></i>
            FAQ</span>
    </button>
</mat-menu> -->